import React from 'react';
import HeroSection from './components/HeroSection';
import HowItWorks from './components/HowItWorks';
import WhoWeHelp from './components/WhoWeHelp';
import RealSavings from './components/RealSavings';
import UploadForm from './components/UploadForm';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="min-h-screen bg-gray-900">
      <HeroSection />
      <HowItWorks />
      <WhoWeHelp />
      <RealSavings />
      <UploadForm />
      <Footer />
    </div>
  );
}

export default App;